export default "__VITE_ASSET__DEgXpqiW__"